<template>
  <MMPopupDefault class="description-modal" @close="$emit('close')">
    <template #header>
      <MMText font="Title L/Semibold" class="header-title"> О товаре </MMText>
    </template>

    <div class="modal-content">
      <div
        v-if="props.onShowData?.description"
        class="description-content editor"
        v-html="props.onShowData.description"
      />
      <div v-else class="empty-state">
        <MMText font="Body M/Regular" color="secondary"> Описание товара не найдено </MMText>
      </div>
    </div>
  </MMPopupDefault>
</template>

<script setup lang="ts">
import { MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';

interface IPopupData {
  description: string;
}

const props = defineProps<{ onShowData: IPopupData }>();

defineEmits<{
  close: [];
}>();
</script>

<style scoped lang="stylus">
.description-modal
  width 100%
  max-width 480px
  max-height 80vh

  +Media(Mobile)
    max-width calc(100vw - 32px)
    max-height calc(100vh - 32px)

.header-title
  text-align center

.modal-content
  padding 12px 16px 12px
  max-height 60vh
  overflow-y auto

  +Media(Mobile)
    max-height calc(100vh - 120px)

.description-content
  line-height 1.5
  color var(--text-primary)

  // Стили для HTML контента
  :deep(p)
    margin 0 0 16px 0
    font-size 14px
    line-height 20px

  :deep(h1, h2, h3, h4, h5, h6)
    margin 0 0 12px 0
    font-weight 600
    line-height 1.3

  :deep(ul, ol)
    margin 0 0 16px 0
    padding-left 20px

  :deep(li)
    margin 0 0 8px 0
    font-size 14px
    line-height 20px

  :deep(strong, b)
    font-weight 600

  :deep(em, i)
    font-style italic

  :deep(a)
    color var(--color-primary)
    text-decoration underline

    &:hover
      text-decoration none

  :deep(img)
    max-width 100%
    height auto
    border-radius 8px
    margin 16px 0

  :deep(blockquote)
    margin 16px 0
    padding 12px 16px
    background-color var(--color-background-secondary)
    border-left 4px solid var(--color-primary)
    border-radius 0 8px 8px 0

  :deep(code)
    background-color var(--color-background-secondary)
    padding 2px 6px
    border-radius 4px
    font-family 'Monaco', 'Menlo', 'Ubuntu Mono', monospace
    font-size 13px

  :deep(pre)
    background-color var(--color-background-secondary)
    padding 16px
    border-radius 8px
    overflow-x auto
    margin 16px 0

    code
      background none
      padding 0

.empty-state
  text-align center
  padding 20px
</style>
